import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import {
  getClosedTrade,
  saveClosedTrade,
} from "../services/closedTradeService";
import { getTradeTypes } from "../services/tradeTypeService";
import { getTradeResponses } from "../services/tradeResponseService";
import Axios from "axios";

class ClosedTradeForm extends Form {
  state = {
    data: {
      user_email: "",
      tradeTypeId: "",
      tradeResponseId: "",
      comment: "",
      trade_reference: "",
    },
    user_email: "",
    trade_reference: "",
    ttypes: [],
    tresponses: [],
    errors: {},
  };

  schema = {
    _id: Joi.string(),
    user_email: Joi.string().label("User Email").allow(null, ""),
    trade_reference: Joi.string().label("Trade Reference").allow(null, ""),
    tradeTypeId: Joi.string().required().label("Trade Type"),
    tradeResponseId: Joi.string().required().label("Trade Response"),
    comment: Joi.string().required().label("Comment"),
  };

  async populateTradeTypes() {
    const { data: ttypes } = (await getTradeTypes()).data;
    // console.log(ttypes);
    this.setState({ ttypes });
  }

  async populateTradeResponses() {
    const { data: tresponses } = await getTradeResponses();
    // console.log(tresponses);
    this.setState({ tresponses });
  }

  async populateClosedTrade() {
    try {
      const TradeId = this.props.match.params.id;
      if (TradeId === "new") return;

      // const { data: closedTrade } = await getClosedTrade(TradeId).data;
      // this.setState({ data: this.mapToViewModel(resp.data) });
      // http://api.jeroid.co
      const resp = await Axios.get(`/trades/${TradeId}`);

      this.setState({
        user_email: resp.data.data.user,
        trade_reference: resp.data.data.trade_reference,
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        return this.props.history.replace("/not-found");
    }
  }

  componentDidMount() {
    this.populateTradeTypes();
    this.populateClosedTrade();
    this.populateTradeResponses();
  }

  mapToViewModel(closedTrade) {
    return {
      _id: closedTrade._id,
      comment: closedTrade.comment,
      trade_reference: closedTrade.trade_reference,
      tradeTypeId: closedTrade.trade_type._id,
      tradeResponseId: closedTrade.trade_response._id,
      user_email: closedTrade.user_email,
    };
  }

  doSubmit = async () => {
    const { data } = this.state;

    data.user_email = this.state.user_email;
    data.trade_reference = this.state.trade_reference;
    // Call the server

    // console.log(data);

    await saveClosedTrade(data);

    this.props.history.push("/closed-trades");
  };

  render() {
    const closedTradeId = this.props.match.params.id;
    return (
      <div className="row">
        <div className="col-md-6 offset-md-3" style={{ marginTop: 50 + "px" }}>
          <div className="text-center">
            <h4
              className="h4 mb-2 login-welcome-text"
              style={{ marginTop: 20 + "px", fontWeight: "bold" }}
            >
              Close a Trade with Feedback to User
            </h4>
            <p style={{ color: "#000524" }}>
              This operation can only be performed by Jeroid Admin
            </p>
          </div>
          <div
            className="card card-register mx-auto mt-2"
            style={{ border: 0, borderRadius: 0, marginBottom: 10 + "%" }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: "white",
                borderBottom: 0,
                marginTop: 2 + "%",
                fontWeight: "bold",
              }}
            >
              Trade Info
            </div>
            <hr
              style={{
                marginRight: 20 + "px",
                marginLeft: 20 + "px",
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="form-row">
                  <div className="col-md-6">
                    {this.renderInput(
                      "user_email",
                      "User Email",
                      "",
                      "autofocus",
                      "text",
                      `${this.state.user_email}`
                    )}{" "}
                  </div>
                  <div className="col-md-6">
                    {this.renderInput(
                      "trade_reference",
                      "Trade Reference",
                      "",
                      "",
                      "text",
                      `${this.state.trade_reference}`
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="col-md-6">
                    {this.renderRegSelect(
                      "tradeTypeId",
                      "Trade Type",
                      this.state.ttypes
                    )}
                  </div>
                  <div className="col-md-6">
                    {this.renderRegSelect(
                      "tradeResponseId",
                      "Response",
                      this.state.tresponses
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="col-md-12">
                    {this.renderTextArea("comment", "Comment", "3", "text")}
                  </div>
                </div>

                <div className="text-center">
                  {/* {closedTradeId === "new" */}
                  {this.renderButton("Save", false)}
                  {/* : this.renderButton("Update")} */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClosedTradeForm;
